import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const CodeReview: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://docs.google.com/document/d/1HptnBZWk8ZS4mT50u9NiYahKZh85SrNGGk1owZGQQAM/edit'>
          Code Review
        </a>
      </h1>
      <h2>¿Porqué es importante el Code Review?</h2>
      <p>
        Existen varios motivos por los que esta práctica es interesante, sin
        embargo, el motivo principal para empezar a implementar Code Review es
        el de mejorar la calidad del código que desarrollamos y crear una
        cultura de equipo en la que todos los desarrolladores se sienten
        importantes. Vamos a analizar distintos motivos destacables: Compromiso
        y motivación: Al incluir Code Review en tu flujo de trabajo, los
        desarrolladores se comprometen más en realizar un código más limpio y a
        consolidar aspectos pendientes. Al saber que tu código va a ser
        revisado, se tiene más precaución, se mima más el código, se incrementa
        el compromiso con el proyecto y aumenta la motivación del desarrollador
        al ser gratificado por el resto de compañeros. Todos necesitamos que nos
        digan “buen trabajo” y nos sintamos parte del equipo.
      </p>
      <h2>¿Cómo hacer un buen Code Review?</h2>
      <p>
        Hay dos personajes importantes a la hora de hacer un code review, quién
        presenta el cambio en un pull request, y quien lo revisa.
      </p>
      <p>
        En el caso de quien presenta el pull request, es importante presentar
        cambios acotados a una problemática en particular (o un conjunto de
        problemáticas agrupadas según algún criterio), siempre pensando en
        facilitarle el proceso de revisión a quién tenga que revisar el código.
        Hay que tener en cuenta, que el pull request no se puede crear con la
        herramienta git, el proceso de creación depende del host de
        repoisitorios utilizado. Por defecto dicho host va a describir el pull
        request con los mensajes de los commits, pero puede ser una buena idea
        expandir esa descripción para mejor claridad de la propuesta.
      </p>
      <p>
        Por otro lado, en el caso de quien revisa, la clave es asumir el
        compromiso de responder por el código que se aprueba. Como reviewer, soy
        tan responsable del cambio como quien lo desarrolla. Tengo que tomarme
        el tiempo de revisarlo apropiadamente y comentar aqueyo que creo
        necesario. A partir del comentario de reviewer, se debe dar una
        discusión en la que podría estar incorporado el PM, el diseñador, o
        quien sea pertinente. Además, como reviewer hay que recordar
        "recomendar" más y "corregir" menos, para tratar de que quien tiene que
        tomar las revisiones no las sienta como un error, si no como una
        oportunidad de mejora.
      </p>
    </Container>
  );
};

export default new Content({
  Component: CodeReview,
  title: "Code Review",
  route: "code-review",
  tags: [
    "buenas",
    "practicas",
    "code",
    "code quality",
    "code-quality",
    "calidad",
    "código",
    "reglas",
    "desarrollo",
    "programación"
  ]
});
